import React, { useEffect, useState } from "react";
import { Input } from "reactstrap";
import { useDispatch } from "react-redux";
import { UpdateStatePayInMetaLevel } from "../../../redux/slices/statePayInMetaSlice";
import { responseToaster } from "../../../helperFunctions";

const StatePayInLevels = ({ data, onGet, disabled }) => {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);

    const staticDataTwo = [
        { value: "is_level1", label: "Level 1" },
        { value: "is_level2", label: "Level 2" },
        { value: "is_level3", label: "Level 3" },
        { value: "is_level4", label: "Level 4" },
    ];

    const [checked, setChecked] = useState({});

    const updateLevel = async (levelKey, status) => {
        try {
            setIsLoading(true);
            const payload = {
                levelKey,
                status,
                stateId: data?.state_id,
                merchantId: data?.merchant_id || "", // Use bank's merchant_id if exists
                pgName: data?.pg_name,
                id: data?.id,
                pgId: data?.pg_id,
            };
            const res = await dispatch(
                UpdateStatePayInMetaLevel(payload)
            ).unwrap();
            responseToaster(res);

            onGet();
            setIsLoading(false);
        } catch (err) {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        setChecked({
            is_level1: data?.is_level1 || 0,
            is_level2: data?.is_level2 || 0,
            is_level3: data?.is_level3 || 0,
            is_level4: data?.is_level4 || 0,
        });
    }, [data]);

    const prepareChecked = (value) => {
        return checked?.[value] === 1;
    };

    return (
        <div className="cell-order">
            <div className="order-singal-div">
                <div className="button-space checkbox-icon">
                    {staticDataTwo?.map((level) => {
                        return (
                            <div className="d-flex align-items-center gap mb-50" key={level.value}>
                                <Input
                                    type="checkbox"
                                    checked={prepareChecked(level?.value)}
                                    onChange={() => {
                                        updateLevel(
                                            level.value,
                                            checked?.[level.value] === 1 ? 0 : 1
                                        );
                                        setChecked({
                                            ...checked,
                                            [level.value]: checked?.[level.value] === 1 ? 0 : 1,
                                        });
                                    }}
                                    disabled={isLoading || disabled}
                                />
                                {level?.label}
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default StatePayInLevels;
